import * as actionTypes from 'constants/actions'

const initialState = {
    selected: {}
}

const selectedReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SELECTED_PARAMETER:
            return action.param
        default: return state
    }
}

export default selectedReducer